export default [
  { name: "All Departments", value: "ALL" },
  { name: "Admin", value: "ADMIN" },
  { name: "Design", value: "DESIGN" },
  { name: "Production", value: "MACHINING" },
  { name: "Finishing", value: "POLISHING" },
  { name: "Warehouse", value: "WAREHOUSE" }
];
